import { SportsEnum } from 'types/generated/client';

export enum HomeDateRangeEnum {
  Today = 'TODAY',
  ThisWeek = 'THIS_WEEK',
  ThisMonth = 'THIS_MONTH',
}

export enum HomeIntentEnum {
  JoinGame = 'JOIN_GAME',
  Compete = 'COMPETE',
  Improve = 'IMPROVE',
  GetFit = 'GET_FIT',
  BookCourt = 'BOOK_COURT',
}

export interface HomeFilters {
  dateRange: HomeDateRangeEnum;
  sport: SportsEnum;
  intent: HomeIntentEnum;
}

export const DEFAULT_HOME_FILTERS: HomeFilters = {
  dateRange: HomeDateRangeEnum.ThisWeek,
  sport: SportsEnum.Pickleball,
  intent: HomeIntentEnum.JoinGame,
};
